.root {
    // because of an exception with the collapsed triggers I can't just set
    // a flex gap like normal, but a nice bonus is that it let me set margins
    // in linkList without creating a mobile variant
    --mobile-submenu-gap: 40px;

    composes: safeContainer from "../../styles/composable/layout.module.css";
}

.backHeader {
    width: 100%;
    display: flex;
    align-items: center;
    height: 56px;
    margin-bottom: 24px;
    border-bottom: 1px solid var(--gray-300);
    font: var(--font-nav-16-lg);
}

.backCaret {
    width: 24px;
    height: 24px;
    fill: currentcolor;
    transform: rotate(180deg) translate(8px, 0.5px);
}

.content {
    composes: listReset from "../../styles/composable/utility.module.css";
    composes: grid from "../../styles/composable/layout.module.css";

    --labui-grid-gap: 0 var(--default-grid-gap);

    // Basically, "get the last list item with .collapsedListTrigger inside"
    li:nth-last-child(1 of :has(.collapsedListTrigger)),
    // "get the last list item with an image (navAd!) inside"
    li:nth-last-child(1 of :has(img)) {
        margin-bottom: var(--mobile-submenu-gap);
    }
}

.fullColumn {
    grid-column: 1 / -1;
}

.halfColumn {
    grid-column: span 2;

    // covers the case of three navAds in a layout
    &:has(img) {
        margin-bottom: calc(var(--mobile-submenu-gap) / 2);
    }
}

.collapsedListTrigger {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 40px;
    font: var(--font-nav-16);
}

.caretIcon {
    width: 24px;
    height: 24px;
    fill: currentcolor;
}
